import { Command } from './Commands';

export class DeletePage extends Command {
  priority: number = 100;
  type: string = 'Page.Delete';
}
